import { FC } from "react";

import ImageCarousel from "components/ImageCarousel";
import Image from "components/Image";

interface ImageTypeProps {
  data: {
    isItemRotatable?: boolean;
    imageAlt?: string;
    itemImageFront: string;
    itemImageBack?: string;
    bgColor?: string | null;
  };
  imageUnoptimized?: boolean;
}

const ImageType: FC<ImageTypeProps> = ({ data, imageUnoptimized }) => {
  const { isItemRotatable, imageAlt, itemImageFront, itemImageBack, bgColor } =
    data;
  const isSantaImage = itemImageFront?.indexOf("uq-chest") !== -1;

  return (
    <>
      {isItemRotatable ? (
        <ImageCarousel
          name={imageAlt}
          front={itemImageFront}
          back={itemImageBack || ""}
          imageUnoptimized={imageUnoptimized}
          bgColor={bgColor}
        />
      ) : (
        <Image
          src={itemImageFront}
          alt={imageAlt}
          width={540}
          height={isSantaImage ? 530 : 630}
          bgColor={bgColor}
          imageUnoptimized={imageUnoptimized}
        />
      )}
    </>
  );
};
export default ImageType;
